import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';


export interface UserToken {
  token: string;
  expires: number;
  refreshToken: string;
  service?: string;
  userGroup?: string;
}

export interface UserInfo {
  name: string;
}
interface AuthState {
  userToken?: UserToken;
  userInfo?: UserInfo;
  status: 'idle' | 'loading' | 'error';
}

const initialState: AuthState = {
  status: 'idle',
  userInfo: undefined,
  userToken: undefined
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserToken(state, action: PayloadAction<UserToken | undefined>) {
      state.userToken = action.payload;
    }
  }
});

export const { setUserToken } = authSlice.actions;
export const getUserToken = (state: RootState) => state.auth.userToken;
export const getUserInfo = (state: RootState) => state.auth.userInfo;
export const isInGroup = (authGroups: string[]) => (state: RootState) => {
  if (state.auth?.userToken?.userGroup && !!authGroups.includes(state.auth.userToken.userGroup)) return true;
  return false;
}
export default authSlice.reducer;
